<template>
  <app-logged id="IndustriasClienteCreate">
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <div class="mb-6">
                <v-input
                  :messages="[`Responsável pelo registro abaixo.`]"
                  prepend-icon="contacts"
                >
                  {{ cliente.nome }} ({{ cliente.cpf_numero }})
                </v-input>
              </div>
              <validation-provider
                name="industria"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :items="industrias"
                  v-model="industriaDoCliente.industria_id"
                  label="Indústria"
                  :return-object="false"
                  item-text="nome_fantasia"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="início do contrato"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="industriaDoCliente.contrato_inicio"
                  label="Início do contrato"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="término do contrato"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  :min="industriaDoCliente.contrato_inicio"
                  v-model="industriaDoCliente.contrato_fim"
                  label="Término do contrato"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="industriaDoCliente.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
export default {
  name: 'IndustriasClienteCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppButton
  },
  computed: {
    ...mapGetters(['industrias', 'cliente', 'industriaDoCliente'])
  },
  methods: {
    ...mapActions(['postSaveIndustriaDoCliente', 'deleteIndustriaDoCliente']),
    goToClienteEdit () {
      this.$router.push({
        name: 'clientes-update',
        params: {
          id: this.cliente.id
        }
      })
    },
    remove () {
      if (
        confirm(`Confirme a exclusão deste vínculo do ${this.cliente.nome}.`)
      ) {
        this.deleteIndustriaDoCliente().then(res => {
          this.goToClienteEdit()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveIndustriaDoCliente({
            clienteId: this.cliente.id
          }).then(res => {
            this.goToClienteEdit()
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
